import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {PdfViewerComponent} from 'ng2-pdf-viewer/dist/pdf-viewer.component';
import {LoaderService} from '@shared/service/loader.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {DigitalSignUtilities} from '../../../../../../../digital-sign/utilities/digital-sign-utilities.model';
import $ from 'jquery/dist/jquery.min';
import {DigitalSignClause, DigitalSignClauses} from '../../../../../../../digital-sign/models/digital-sign-clauses';
import {DigitalSignEventsService} from '@shared/components/core-sign/services/digital-sign-events.service';
import {DigitalSignOperatorStartedProcess} from '../../../../../../../digital-sign/models/digital-sign-started-operator-process.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-operator-procedure-start',
	templateUrl: './digital-sign-operator-procedure-start.component.html',
	styleUrls: ['./digital-sign-operator-procedure-start.component.scss']
})
export class DigitalSignOperatorProcedureStartComponent implements OnInit, OnChanges {

	@Input() dsStartedProcess: DigitalSignOperatorStartedProcess;
	@Input() operatorToken: string;
	@Input() module: string;

	currentDocument: number = -1;
	readyToShowDocuments: boolean;
	pdfBuffer: ArrayBuffer[];
	approvedConditions: Map<number, boolean[]>;
	isAllChecked: boolean;

	@ViewChild(PdfViewerComponent) private pdfComponent: PdfViewerComponent;
	translateContext = TranslateContext;

	constructor(
		private digitalSignEventsService: DigitalSignEventsService,
		public loaderService: LoaderService
	) {
		this.approvedConditions = new Map<number, boolean[]>();
		this.pdfBuffer = [];
	}

	ngOnInit(): void {
		this.digitalSignEventsService.getLoadedInfocertDocumentObservable.subscribe(
			document => {
				this.pdfBuffer[document.index] = DigitalSignUtilities.base64ToArrayBuffer(Utilities.escapeBase64(document.document));
				this.loaderService.display(false);
			}
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!!changes.operatorToken) {
			this.operatorToken = changes.operatorToken.currentValue;
		}
		if (!!changes.dsStartedProcess) {
			this.dsStartedProcess = changes.dsStartedProcess.currentValue;
		}

		if (!!this.operatorToken && !!this.dsStartedProcess) {
			const length: number = this.dsStartedProcess.documents.length;
			let signLength: number;
			for (let i: number = 0; i < length; i++) {
				signLength = this.dsStartedProcess.documents[i].signatures.length;
				this.approvedConditions.set(i, new Array(signLength).fill(false));
				this.pdfBuffer.push(null);
				this.loadInfocertDocument(i, this.dsStartedProcess.documents[i].url);
			}
			this.currentDocument = 0;
			this.readyToShowDocuments = true;
		}

	}

	loadInfocertDocument(index: number, urlFile: any): void {
		this.loaderService.display(true);
		this.digitalSignEventsService.loadInforcertDocumentSubject.next({
			token: this.operatorToken,
			urlFile: urlFile,
			index: index
		});
	}

	downloadInfocertDocument(index: number): void {
		this.digitalSignEventsService.downloadInforcertDocumentSubject.next(
			{
				mUrl: this.dsStartedProcess.documents[index].url,
				token: this.operatorToken,
				name: this.dsStartedProcess.documents[index].name
			}
		);
	}

	checkBoxChange(event: any): void {
		if (event.checked) {
			this.isAllCheckedMethod();
		} else {
			this.isAllChecked = false;
		}
	}

	isAllCheckedMethod(): void {
		const keys1: number[] = Array.from(this.approvedConditions.keys());
		for (let i: number = 0; i < keys1.length; i++) {
			if (!this.isDocumentAllChecked(keys1[i])) {
				this.isAllChecked = false;
				return;
			}
		}
		this.isAllChecked = true;
	}

	isDocumentAllChecked(key: number): boolean {
		const values: boolean[] = Array.from(this.approvedConditions.get(key));
		for (let j: number = 0; j < values.length; j++) {
			if (!values[j]) {
				return false;
			}
		}
		return true;
	}

	openOperatorOTPDialog(): void {
		if (this.currentDocument === 0) {
			this.currentDocument = 1;
			this.scrollToPage(0);
			Utilities.scrollUp($);
		} else if (this.currentDocument === 1) {
			this.digitalSignEventsService.openOperatorOtpDialogSubject.next({
				documents_singed: this.getAcceptedClauses()
			});
		}
	}

	scrollToPage(page: number): void {
		if (!Utilities.isVoid(this.pdfComponent) && !Utilities.isVoid(this.pdfComponent.pdfViewer)) {
			this.pdfComponent.pdfViewer.scrollPageIntoView({
				pageNumber: page
			});
		}
	}

	private getAcceptedClauses(): any {
		const result: DigitalSignClauses[] = [];
		const keys1: number[] = Array.from(this.approvedConditions.keys());
		for (let i: number = 0; i < this.dsStartedProcess.documents.length; i++) {
			const clauses: DigitalSignClauses = new DigitalSignClauses(this.dsStartedProcess.documents[i].id);
			const values1: boolean[] = Array.from(this.approvedConditions.get(keys1[i]));
			for (let j: number = 0; j < values1.length; j++) {
				clauses.addClause(new DigitalSignClause(this.dsStartedProcess.documents[i].signatures[j].id, values1[j]));
			}
			result.push(clauses);
		}
		return result;
	}

	abortProcedure(): void {
		this.digitalSignEventsService.abortOperatorProcedureSubject.next();
	}
}
